'use client';

import { Product } from 'lib/bigcommerce/types';
import { useCallback, useEffect, useState } from 'react';

async function getProductBySku(sku?: string): Promise<Product | undefined> {
  if (!sku) return;

  const response = await fetch(`/api/product?sku=${sku}`);
  if (response.ok) {
    const result = await response.json();
    return result;
  }
  throw new Error(`Error ${response.status}: ${response.statusText}`)
}

export default function useProduct({ sku }: { sku?: string }) {
  const [product, setProduct] = useState<Product | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  const fetchProduct = useCallback(async () => {
    setLoading(true);
    setError(undefined);
    try {
      const result = await getProductBySku(sku);
      setProduct(result);
    } catch (error: any) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [sku]);

  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  if (error) {
    console.log(error);
  }

  return {
    loading,
    product,
    refetch: fetchProduct
  };
}
